// @flow

import * as React from 'react'
import RCSlider from 'rc-slider'

import 'rc-slider/assets/index.css'
import './slider.css'

const Range = RCSlider.createSliderWithTooltip(RCSlider.Range)

type State = {|
  value: [number, number],
|}

type Props = {|
  min: number,
  max: number,
  onChange: ([number, number]) => void,
  onAfterChange: ([number, number]) => void,
  tipFormatter: number => any,
|}

class Slider extends React.Component<Props, State> {
  static defaultProps = {
    onChange: () => {},
    onAfterChange: () => {},
    tipFormatter: (v: number) => v,
  }
  state = {
    value: [0, 0],
  }

  componentDidMount() {
    this.setState({
      value: [this.props.min, this.props.max > 0 ? this.props.max : 0],
    })
  }
  componentWillReceiveProps(newProps: Props) {
    if (newProps.min !== this.props.min || newProps.max !== this.props.max) {
      this.setState({
        value: [newProps.min, newProps.max > 0 ? newProps.max : 0],
      })
    }
  }

  onChange = (values: [number, number]) => {
    if (values[0] !== this.state.value[0]) {
      //Move left handle
      if (values[0] === this.state.value[1]) {
        values[0]--
      }
    }
    if (values[1] !== this.state.value[1]) {
      //Move right handle
      if (values[1] === this.state.value[0]) {
        values[1]++
      }
    }
    this.setState({
      value: values,
    })
    this.props.onChange(values)
  }

  render() {
    return (
      <div style={{ width: '100%', position: 'relative' }}>
        <Range
          min={this.props.min}
          max={this.props.max}
          allowCross={false}
          value={this.state.value}
          onChange={this.onChange}
          onAfterChange={this.props.onAfterChange}
          tipFormatter={this.props.tipFormatter}
        />
      </div>
    )
  }
}

export default Slider



// WEBPACK FOOTER //
// ./src/reports/slider.js